module.exports = __webpack_public_path__ + "img/knife.combat.3821a839.png";